import { SectionConfig } from '@msaf/core-react'
import { createContext, useContext, PropsWithChildren } from 'react'

export interface WorkflowState {
  navigationSteps: SectionConfig[]
}

const WorkflowContext = createContext<WorkflowState | undefined>(undefined)

export default function WorkflowStateProvider({ children, ...props }: PropsWithChildren<WorkflowState>) {
  return <WorkflowContext.Provider value={props}>{children}</WorkflowContext.Provider>
}

function useWorkflowState() {
  const context = useContext(WorkflowContext)
  if (context === undefined) {
    throw new Error('useWorkflowState must be used within a WorkflowStateProvider')
  }
  return context
}

export { useWorkflowState }
